
/**
 * 메시지 역할
 */
export type AddConversationMessageBodyRole = typeof AddConversationMessageBodyRole[keyof typeof AddConversationMessageBodyRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddConversationMessageBodyRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
